import LogoIcon from '@/assets/icons/icon-logo.svg'
import { classNames } from '@/utils/helpers'

interface LogoPlaceholderProps {
  showText?: boolean
}

export const LogoPlaceholder = ({ showText = true }: LogoPlaceholderProps) => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-secondary-200 dark:bg-secondary-600 opacity-30 hover:opacity-20 dark:opacity-5 dark:hover:opacity-15 hover:scale-105 transition-all">
      <LogoIcon className="left-0 top-0 h-1/2 w-1/2 transition-transform duration-200 text-white" />
      <span
        className={classNames('text-sm text-white', {
          'text-opacity-0': !showText,
        })}
      >
        Media unavailable
      </span>
    </div>
  )
}
